import Animation from './animation'

/*
 * This animation is used when multiple series grouped are combined into
 * a stacked bar. Some of the columns end up being removed.
 */
class SplitRemoveAnimation extends Animation {

  constructor (options) {
    super(options)
    this.twoPart = true
    this.ripple = true
  }

  match (serie) {
    if (!this.chart.previous) {
      return false // not an update
    }

    return this.chart.layout.columnCount() < this.chart.previous.layout.columnCount() ||
           ((this.chart.previous.layout.breakdown.calculated && this.chart.layout.breakdown.calculated) && // Previously and still in no-breakdown mode
            this.exitingSeries.size()) // no breakdown style chart and series were removed
  }

  animate (serie, entering, selection, merged) {
    this.chart.yTransition.duration(this.timing.duration) // Sync the y-axis w/ the left-most transition

    let transition = merged.delay(this.timing.delay)
                           .duration(this.timing.duration)

    if (this.exitingSeries.size() && this.exitingSeries.filter(exiting => exiting.id === serie.id).size()) {
      // This serie is shrinking to 0 height, we want to make sure its top/bottom borders fade out
      transition.tween('decorations', this.tweeners.decorations)
    }

    // Set a delay on the transition to create the ripple effect
    transition.tween('vertical', this.tweeners.vertical)
              .transition()
              .tween('horizontal', this.tweeners.horizontal)
              .tween('decorations', this.tweeners.decorations)
  }

}

export default SplitRemoveAnimation
